// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-form[data-v-4011ed0b] {\n  margin-bottom: 20px;\n}\n.pagination-container[data-v-4011ed0b] {\n  margin-top: 20px;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
